import React from "react";
import { useNavigate } from "react-router-dom"; // Updated import
import { Button } from "pepsico-ds";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        color: "#333",
      }}
    >
      <div
        className="$font-heading-h3-medium"
        style={{
          fontWeight: 700,
          marginBottom: "16px",
        }}
      >
        404 - Page Not Found
      </div>
      <div
        className="$font-heading-h6-medium"
        style={{
          fontWeight: 400,
          marginBottom: "16px",
        }}
      >
        Oops! The page you're looking for does not exist.
      </div>
      <Button
        variant="primary"
        onClick={() => navigate("/")}
        size="medium"
        style={{ marginTop: 2 }}
      >
        Go Back Home
      </Button>
    </div>
  );
};

export default NotFound;
